import React, { useEffect, useState } from 'react'
import { Breadcrumb, Button, Card, Col, Flex, Row, Space, Table, Tag, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { jobData } from '../../../Data';
import { apiCalls } from '../../../shared/Apis';
import { TableLoader } from '../../../shared';

const { Text } = Typography
const JobSingleView = () => {
    let { jobId } = useParams()
    const navigate = useNavigate() 
    const [ loading, setLoading ] = useState()
    const [ singleData, setSingleData ] = useState(null)

    const SingleViewTrackJob = async() => {
        setLoading(true)
        const result = await apiCalls?.addJobapi?.SingleViewTrackJob(jobId)
        if(result)
            setSingleData(result)
            setLoading(false)
    }

    useEffect(()=>{
        SingleViewTrackJob()
    },[jobId])


    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            width: 150,
        },
        {
            title: 'Detail',
            dataIndex: 'detail',
            width: 150,
        },
    ];
    const data = [
        {
            key: '1',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Job Title</Text>
                <Text>
                    {singleData?.data?.job?.service?.name}
                </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Organization Name</Text>
                <Text>{singleData?.data?.job?.organizationName}</Text>
            </Space>,
        },
        {
            key: '2',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>User Name</Text>
                {
                    singleData ? 
                    <Text>
                        {singleData?.data?.firstName?.charAt(0).toUpperCase() + singleData?.data?.firstName?.slice(1)}{' '}
                        {singleData?.data?.lastName?.charAt(0).toUpperCase() + singleData?.data?.lastName?.slice(1)}
                    </Text>
                    :
                    null
                }
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Budget</Text>
                <Text>{singleData?.data?.job?.budget}</Text>
            </Space>,
        },
        {
            key: '3',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Email</Text>
                <Text>{singleData?.data?.email}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Contact No</Text>
                <Text>{singleData?.data?.contactNumber}</Text>
            </Space>,
        },
        {
            key: '4',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>City</Text>
                <Text>{singleData?.data?.city} </Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Country</Text>
                <Text>{singleData?.data?.country}</Text>
            </Space>,
        },
        {
            key: '5',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Address</Text>
                <Text>{singleData?.data?.address}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Date</Text>
                <Text>{singleData?.data?.date}</Text>
            </Space>,
        },
        {
            key: '6',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Experience</Text>
                <Text>{singleData?.data?.experience} Year{singleData?.data?.experience > 1 ? 's':''}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Message</Text>
                <Text>{singleData?.data?.message}</Text>
            </Space>,
        },
        {
            key: '7',
            title: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Cv</Text>
                <Text>{singleData?.data?.cvName}</Text>
            </Space>,
            detail: <Space direction='vertical' size={2}>
                <Text className='text-gray'>Services</Text>
                <Flex gap={5} wrap>
                    {
                        singleData?.services?.map((data)=>
                            <Tag className='brand-text border-brand'>
                                {data?.name}
                            </Tag>
                        )
                    }
                </Flex>
            </Space>,
        },
    ];

    return (
        <div>
            <Breadcrumb className='mb-3'
                separator=">"
                items={[
                    {
                      title: <Text className='cursor text-gray' onClick={()=>navigate('/job')}>Job</Text>,
                    },
                    {
                      title: 
                      <Text className='fw-500'>  
                        {
                            singleData ?
                                <>
                                    {singleData?.data?.firstName?.charAt(0).toUpperCase() + singleData?.data?.firstName?.slice(1)}{' '}
                                    {singleData?.data?.lastName?.charAt(0).toUpperCase() + singleData?.data?.lastName?.slice(1)}
                                </>
                            :null
                            }
                      </Text>,
                    },
                ]}
            />
            <Card className='shadow-d radius-12 mb-3'>
                <Row gutter={[24, 24]}>
                    <Col span={24}>
                        <Space>
                            <Button className='border0 p-0 bg-transparent' onClick={()=>navigate('/job')}>
                                <ArrowLeftOutlined />
                            </Button>
                            {
                                singleData ? 
                                <>
                                    <Text className='fw-500'>
                                        {singleData?.data?.firstName?.charAt(0).toUpperCase() + singleData?.data?.firstName?.slice(1)}{' '}
                                        {singleData?.data?.lastName?.charAt(0).toUpperCase() + singleData?.data?.lastName?.slice(1)}
                                    </Text>
                                    {
                                        singleData?.data?.status === 1 ? (
                                            <Text className='badge-cs pending fs-12'>Pending</Text>
                                        ) : singleData?.data?.status === 2 ? (
                                            <Text className='badge-cs active fs-12'>Active</Text>
                                        ) : (
                                            <Text className='badge-cs inactive fs-12'>Inactive</Text>
                                        )
                                    }
                                </>
                                :
                                null
                            }
                        </Space>
                    </Col>  
                    <Col span={24}>
                        <Table 
                            size='large'
                            columns={columns} 
                            dataSource={data} 
                            scroll={{x: 1000}}
                            className='pagination'
                            showSorterTooltip={false}
                            rowHoverable={false}
                            showHeader={false}
                            pagination={false}
                            loading={
                                {
                                    ...TableLoader,
                                    spinning: loading
                                }
                            }
                        />
                    </Col>
                </Row>
            </Card>
        </div>
    )
}

export { JobSingleView }
